import { ConfirmComponent } from '$components/dialog/confirm.component';
import { HeaderComponent } from '$components/header/header.component';
import { HomeButtonComponent } from '$components/header/home-button/home-button.component';
import { LanguageButtonComponent } from '$components/header/language-button/language-button.component';
import { LogoComponent } from '$components/header/logo/logo.component';
import { MenuButtonComponent } from '$components/header/menu-button/menu-button.component';
import { MenuComponent } from '$components/header/menu-button/menu/menu.component';
import { MenuDesktopComponent } from '$components/header/menu-desktop/menu-desktop.component';
import { UserConnectedComponent } from '$components/header/user-connected/user-connected.component';
import { ActionsComponent } from '$components/login/actions/actions.component';
import { FormComponent } from '$components/login/form/form.component';
import { TitleComponent } from '$components/login/title/title.component';
import { NavbarComponent } from '$components/navbar/navbar.component';
import { PaymentButtonComponent } from '$components/payment-button/payment-button.component';
import { FiltersComponent } from '$components/posts/filters/filters.component';
import { ModeratorComponent } from '$components/posts/moderator/moderator.component';
import { MainInfoComponent } from '$components/posts/post-display/main-info/main-info.component';
import { MediaComponent } from '$components/posts/post-display/media/media.component';
import { PostDisplayComponent } from '$components/posts/post-display/post-display.component';
import { SecondaryInfoComponent } from '$components/posts/post-display/secondary-info/secondary-info.component';
import { ThirdInfoComponent } from '$components/posts/post-display/third-info/third-info.component';
import { PostFormComponent } from '$components/posts/post-form/post-form.component';
import { PostNotFoundComponent } from '$components/posts/post-not-found/post-not-found.component';
import { PostUpdateComponent } from '$components/posts/post-update/post-update.component';
import { PostsComponent } from '$components/posts/posts.component';
import { StatusTagComponent } from '$components/status-tag/status-tag.component';
import { AuthGuard } from '$guards/auth.guard';
import { CgvPageComponent } from '$pages/cgv-page/cgv-page.component';
import { ContactPageComponent } from '$pages/contact-page/contact-page.component';
import { LoginPageComponent } from '$pages/login/login-page.component';
import { UpdatePasswordPageComponent } from '$pages/update-password/update-password-page.component';
import { PaymentPageComponent } from '$pages/payment/payment.component';
import { CreatePostPageComponent } from '$pages/posts/create-post-page/create-post-page.component';
import { CreateUpdateComponent } from '$pages/posts/crud/create-update/create-update.component';
import { DisplayPostPageComponent } from '$pages/posts/display-post-page/display-post-page.component';
import { PostsPageComponent } from '$pages/posts/posts-page.component';
import { WarningPopupComponent } from '$pages/posts/warning-popup/warning-popup.component';
import { SignupFinishPageComponent } from '$pages/signup/signup-finish/signup-finish.component';
import { SignupPageComponent } from '$pages/signup/signup.component';
import { httpInterceptorProviders } from '$services/auth/http.interceptor';
import { MatSelectCountryModule } from '@angular-material-extensions/select-country';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserSelectComponent } from './components/users/user-select/user-select.component';
import { RenewComponent } from './pages/payment/renew/renew.component';
import { EuroPipe } from '$pipes/euro.pipe';
import { ClientsComponent } from './pages/clients/clients.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FooterComponent } from './components/footer/footer.component';
import { MenuBarComponent } from './components/menu-bar/menu-bar.component';
import { MatTableFilterModule } from 'mat-table-filter';
import { AngularImageViewerModule } from "@hreimer/angular-image-viewer";
import { GalleriaModule } from 'primeng/galleria';
import { ImageModule } from 'primeng/image';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { SpinnerComponent } from './components/spinner/spinner.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginPageComponent,
    UpdatePasswordPageComponent,
    SignupPageComponent,
    PostsPageComponent,
    DisplayPostPageComponent,
    CreatePostPageComponent,
    ContactPageComponent,
    SignupFinishPageComponent,
    PaymentPageComponent,
    CgvPageComponent,
    PostsComponent,
    CreateUpdateComponent,
    LanguageButtonComponent,
    FiltersComponent,
    NavbarComponent,
    PaymentButtonComponent,
    StatusTagComponent,
    LogoComponent,
    HeaderComponent,
    HomeButtonComponent,
    UserConnectedComponent,
    MenuButtonComponent,
    MenuComponent,
    PostDisplayComponent,
    PostNotFoundComponent,
    ModeratorComponent,
    MainInfoComponent,
    SecondaryInfoComponent,
    MenuDesktopComponent,
    TitleComponent,
    FormComponent,
    ActionsComponent,
    PostUpdateComponent,
    PostFormComponent,
    WarningPopupComponent,
    ConfirmComponent,
    ThirdInfoComponent,
    MediaComponent,
    UserSelectComponent,
    RenewComponent,
    EuroPipe,
    ClientsComponent,
    FooterComponent,
    MenuBarComponent,
    SpinnerComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    MaterialFileInputModule,
    MatPaginatorModule,
    MatToolbarModule,
    MatTableFilterModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    AngularImageViewerModule,
    GalleriaModule,
    ImageModule,
    ButtonModule,
    MessagesModule,
    MessageModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatSelectCountryModule.forRoot('fr')
  ],
  providers: [AuthGuard, httpInterceptorProviders,DatePipe],
  bootstrap: [AppComponent],
})
export class AppModule { }
